/* Pistacho — ficha ?view=2: o que faltava para vender.

   Corre depois do pdp-2.js e nao lhe mexe por dentro: ouve o evento
   `pdp2:escolha` que ele ja dispara a cada toque (e le a primeira escolha em
   raiz._pdp2Escolha) e trata de tres coisas que a ficha antiga fazia e esta nao:

     1. o preco de cada opcao, dito debaixo da opcao;
     2. o conjunto da cama (estrado e colchao na medida da cama, no mesmo
        carrinho) e o pack (a peca que o completa, com o desconto que o
        carrinho vai dar);
     3. a mensagem do WhatsApp com a peca e a escolha la dentro.
*/
(function () {
  'use strict';

  var raiz = document.querySelector('[data-pdp2]');
  if (!raiz) return;
  var D;
  try { D = JSON.parse(raiz.querySelector('[data-pdp2-dados]').textContent); } catch (e) { return; }
  var variantes = D.variantes || [];
  // As frases vem dos locales (bloco data-pdp2-t da seccao, na lingua da pagina).
  var T = {};
  try { T = JSON.parse(raiz.querySelector('[data-pdp2-t]').textContent) || {}; } catch (e) { T = {}; }
  function tr(k, v) {
    var s = T[k] || '';
    if (v) Object.keys(v).forEach(function (n) { s = s.split('{' + n + '}').join(v[n]); });
    return s;
  }
  var opcoes = D.opcoes || [];

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  // O mesmo formato do resto da ficha, que vem do `money` da loja: €1.245,00.
  function moeda(c) {
    var v = (Math.abs(c) / 100).toFixed(2).split('.');
    return '€' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
  }
  function enumera(ns) { return ns.length > 1 ? ns.slice(0, -1).join(', ') + tr('e') + ns[ns.length - 1] : ns[0]; }
  function varPorId(id) {
    for (var i = 0; i < variantes.length; i++) if (String(variantes[i].id) === String(id)) return variantes[i];
    return null;
  }

  // As versoes e o conjunto tambem sao escolha: uma peca so com versoes nao
  // pode ficar com a seccao escondida (o pdp-2.js esconde-a quando nao ha
  // eixos).
  var secEsc = raiz.querySelector('#escolher');
  if (secEsc && secEsc.hidden && raiz.querySelector('[data-pdp2-versoes], [data-pdp2-conjunto], [data-pdp2-pack]')) secEsc.hidden = false;

  /* ---- 1. o preco de cada opcao ---------------------------------------- */

  // A regra da ficha antiga (snippets/preco-por-opcao), que saiu de medir a
  // matriz real: os saltos leem-se contra a SELECCAO ACTUAL, nunca somados a
  // partir de um preco-base (em 4 produtos os saltos nao sao aditivos); e
  // "nao muda o preco" so se diz de uma opcao que nao o muda em NENHUMA
  // combinacao.
  var SEP = '\u001f';
  var mapa = {};
  variantes.forEach(function (v) { mapa[v.o.join(SEP)] = v.c; });
  function preco(combo) { var c = mapa[combo.join(SEP)]; return c === undefined ? null : c; }
  var livre = opcoes.map(function (o, i) {
    if (o.valores.length < 2) return true;
    for (var k = 0; k < variantes.length; k++) {
      for (var j = 0; j < o.valores.length; j++) {
        var combo = variantes[k].o.slice();
        combo[i] = o.valores[j];
        var q = preco(combo);
        if (q !== null && q !== variantes[k].c) return false;
      }
    }
    return true;
  });
  var haPaga = opcoes.some(function (o, i) { return o.valores.length > 1 && !livre[i]; });

  function pintarCustos(actual) {
    if (!haPaga || !actual) return;
    var base = preco(actual);
    if (base === null) return;
    opcoes.forEach(function (o, i) {
      var bloco = raiz.querySelector('.pdp2-escolha [data-pdp2-eixo="' + i + '"]');
      if (!bloco || o.valores.length < 2) return;
      var p = bloco.querySelector('.pdp2-eixo__custo');
      if (!p) {
        p = document.createElement('p');
        p.className = 'pdp2-eixo__custo';
        var sw = bloco.querySelector('.pdp2-swatches');
        if (sw) sw.insertAdjacentElement('afterend', p); else bloco.appendChild(p);
      }
      if (livre[i]) { p.textContent = tr('nao_muda_preco'); p.setAttribute('data-livre', ''); return; }
      var porSalto = {};
      o.valores.forEach(function (val) {
        if (val === actual[i]) return;
        var combo = actual.slice();
        combo[i] = val;
        var q = preco(combo);
        if (q === null || q === base) return;
        (porSalto[q - base] = porSalto[q - base] || []).push(val);
      });
      var saltos = Object.keys(porSalto).sort(function (a, b) { return a - b; });
      p.hidden = !saltos.length;
      p.innerHTML = saltos.map(function (d) {
        return tr(d > 0 ? 'salto_mais' : 'salto_menos', { v: '<b>' + esc(enumera(porSalto[d])) + '</b>', p: moeda(+d) });
      }).join(' ');
    });
  }

  /* ---- 2. o conjunto da cama e o pack --------------------------------- */

  var cj = raiz.querySelector('[data-pdp2-conjunto]');
  var CJ = null;
  if (cj) {
    try { CJ = JSON.parse(raiz.querySelector('[data-pdp2-conjunto-dados]').textContent); } catch (e) { CJ = null; }
  }
  var pk = raiz.querySelector('[data-pdp2-pack]');
  var PK = null;
  if (pk) {
    try { PK = JSON.parse(raiz.querySelector('[data-pdp2-pack-dados]').textContent); } catch (e) { PK = null; }
    if (!PK || !PK.ops || !PK.ops.length) { PK = null; pk.hidden = true; }
  }
  // O estrado e o colchao contam para os packs Quarto Completo (8 %) e Pronto
  // a Dormir (10 %): estao nas coleccoes que a Function le (Estrados,
  // Colchoes) desde 28-09-2026 — medido num carrinho nesse dia, cama + estrado
  // + colchao + 2 mesas deu Pronto a Dormir, 10 % nas cinco pecas. Se sairem
  // dessas coleccoes, isto volta a false, senao a pagina promete o que o
  // carrinho nao da.
  var CJ_CONTA = true;
  var escolhaCj = { estrado: -1, colchao: -1 };
  // o complemento do pack: qual (i), os valores das opcoes dele (o), e se o
  // cliente ja lhes mexeu — enquanto nao mexer, seguem o acabamento da peca
  var escolhaPk = { i: -1, o: null, mexeu: false };
  var camaActual = null;

  // As regras da Function `pack-discounts` vivem em assets/packs-contas.js,
  // partilhadas com o Mix and Match: as duas paginas fazem as mesmas contas.
  var packsDe = window.PistachoPacks ? window.PistachoPacks.packsDe : function () { return { packs: [], menos: 0 }; };

  // A medida da cama le-se da variante: "QUEEN SIZE (1600X2000)" -> 1600. O
  // estrado e o colchao tem variantes "1600x2000".
  function medidaDa(v) {
    var m = v && /1[4-9]\d0/.exec(v.o.join(' '));
    return m ? m[0] : '';
  }
  function compDe(tipo, i) {
    if (!CJ || i < 0) return null;
    var lista = tipo === 'estrado' ? CJ.estrados : CJ.colchoes;
    var prod = lista && lista[i];
    if (!prod) return null;
    var m = medidaDa(camaActual);
    if (!m) return null;
    for (var k = 0; k < prod.v.length; k++) if (prod.v[k].t.indexOf(m) > -1) return { nome: prod.nome, v: prod.v[k], cat: CJ_CONTA ? (tipo === 'estrado' ? 'estrados' : 'colchoes') : null };
    return null;
  }
  function extras() {
    return ['estrado', 'colchao'].map(function (t) { return compDe(t, escolhaCj[t]); }).filter(Boolean);
  }

  // O complemento do pack: a variante que corresponde aos valores escolhidos.
  function varDoOp(op, vals) {
    for (var k = 0; k < op.v.length; k++) {
      if (op.v[k].o.join(SEP) === vals.join(SEP)) return op.v[k];
    }
    return null;
  }
  // Os valores de partida: os que a peca ja tem (Madeira Carvalho na cama,
  // Madeira Carvalho na mesa), senao os da primeira variante disponivel.
  function valoresIniciais(op) {
    var daPeca = camaActual ? camaActual.o : [];
    var primeira = op.v.filter(function (v) { return v.ok; })[0] || op.v[0];
    var vals = op.opcoes.map(function (o, i) {
      for (var j = 0; j < o.valores.length; j++) if (daPeca.indexOf(o.valores[j]) > -1) return o.valores[j];
      return primeira.o[i];
    });
    var v = varDoOp(op, vals);
    return v && v.ok ? vals : primeira.o.slice();
  }
  function complemento() {
    if (!PK || escolhaPk.i < 0) return null;
    var op = PK.ops[escolhaPk.i];
    var v = op && escolhaPk.o && varDoOp(op, escolhaPk.o);
    return v && v.ok ? { op: op, v: v, q: PK.qtd } : null;
  }
  function catDaPeca() { return PK ? PK.ancora : (CJ ? 'camas' : null); }

  // Tudo o que o botao vai pôr no carrinho, e as contas que o carrinho vai fazer.
  function contas() {
    var linhas = [{ k: 'peca', cat: catDaPeca(), c: camaActual.c, q: 1 }];
    extras().forEach(function (e, n) {
      linhas.push({ k: 'cj' + n, cat: e.cat, c: e.v.c, q: 1 });
    });
    var comp = complemento();
    if (comp) linhas.push({ k: 'pk', cat: PK.cat, c: comp.v.c, q: comp.q });
    var bruto = linhas.reduce(function (s, l) { return s + l.c * l.q; }, 0);
    var r = packsDe(linhas);
    return { bruto: bruto, packs: r.packs, menos: r.menos, total: bruto - r.menos, comp: comp };
  }

  var NUM = [''].concat((tr('numeros') || '').split(','));
  function nomeComp(comp) {
    return (comp.q > 1 ? comp.q + ' ' + (PK.uns || PK.um) : PK.um) + ' ' + comp.op.t;
  }

  function pintarPack(k) {
    if (!PK) return;
    pk.querySelectorAll('[data-pdp2-pk]').forEach(function (b) {
      var i = +b.getAttribute('data-pdp2-pk');
      b.setAttribute('aria-pressed', escolhaPk.i === i ? 'true' : 'false');
      // a imagem do escolhido segue o acabamento escolhido
      var img = b.querySelector('[data-pdp2-pk-img]');
      if (img && escolhaPk.i === i && k.comp && k.comp.v.img && img.getAttribute('src') !== k.comp.v.img) img.setAttribute('src', k.comp.v.img);
    });
    // A frase diz o pack que o carrinho vai mesmo aplicar a esta escolha —
    // com estrado e colchao ja escolhidos, e outro pack e outra percentagem.
    var nota = pk.querySelector('[data-pdp2-pack-nota]');
    var alvo = k;
    if (!k.comp) {
      var op0 = PK.ops[0], v0 = varDoOp(op0, valoresIniciais(op0)) || op0.v[0];
      var lin = [{ k: 'peca', cat: catDaPeca(), c: camaActual.c, q: 1 }, { k: 'pk', cat: PK.cat, c: v0.c, q: PK.qtd }];
      extras().forEach(function (e, n) { lin.push({ k: 'cj' + n, cat: e.cat, c: e.v.c, q: 1 }); });
      alvo = packsDe(lin);
    }
    var p0 = alvo.packs[0];
    if (nota && p0) {
      nota.textContent = tr('pack_nota', { varias: PK.varias, pack: p0.nome, pct: p0.pct, n: NUM[p0.unidades] || p0.unidades });
    }
    var det = pk.querySelector('[data-pdp2-pack-det]');
    if (!det) return;
    if (!k.comp) { det.hidden = true; det.innerHTML = ''; return; }
    var op = k.comp.op;
    var eixos = op.opcoes.filter(function (o) { return o.valores.length > 1 && o.nome !== 'Title'; }).map(function (o) {
      var i = op.opcoes.indexOf(o);
      return '<div class="pdp2-pack__eixo" role="group" aria-label="' + esc(o.nome) + '">' +
        '<p class="pdp2-conjunto__r">' + esc(o.nome) + '</p>' +
        '<div class="pdp2-swatches pdp2-swatches--medida">' + o.valores.map(function (val) {
          var t = escolhaPk.o.slice(); t[i] = val;
          var vv = varDoOp(op, t);
          return '<button type="button" class="pdp2-medida" data-pdp2-pk-eixo="' + i + '" data-valor="' + esc(val) + '" aria-pressed="' + (escolhaPk.o[i] === val) + '"' + (vv && vv.ok ? '' : ' disabled') + '>' + esc(val) + '</button>';
        }).join('') + '</div></div>';
    }).join('');
    var pp = k.packs[0];
    det.innerHTML =
      (eixos ? '<div class="pdp2-pack__eixos">' + eixos + '</div>' : '') +
      '<dl class="pdp2-pack__contas">' +
        '<div><dt>' + esc(nomeComp(k.comp)) + '</dt><dd>' + moeda(k.comp.v.c * k.comp.q) + '</dd></div>' +
        (pp ? '<div><dt>' + esc(tr('pack_menos', { pack: pp.nome, pct: pp.pct })) + '</dt><dd>−' + moeda(k.menos) + '</dd></div>' : '') +
        '<div class="pdp2-pack__total"><dt>' + esc(tr('total')) + '</dt><dd>' + moeda(k.total) + '</dd></div>' +
      '</dl>' +
      '<button type="button" class="pdp2-pack__tirar" data-pdp2-pk-tirar>' + esc(tr('sem', { x: PK.qtd > 1 ? (PK.uns || PK.um) : PK.um })) + '</button>';
    det.hidden = false;
  }

  function pintarConjunto() {
    if (!camaActual || (!CJ && !PK)) return;
    if (CJ) {
      cj.querySelectorAll('[data-pdp2-cj]').forEach(function (b) {
        var t = b.getAttribute('data-pdp2-cj'), i = +b.getAttribute('data-i');
        if (i >= 0) {
          var c = compDe(t, i);
          b.disabled = !c;
          var s = b.querySelector('[data-pdp2-cj-c]');
          if (s) s.textContent = c ? '+ ' + moeda(c.v.c) : '';
          // uma escolha que deixou de existir nesta medida sai
          if (!c && escolhaCj[t] === i) escolhaCj[t] = -1;
        }
      });
      cj.querySelectorAll('[data-pdp2-cj]').forEach(function (b) {
        b.setAttribute('aria-pressed', escolhaCj[b.getAttribute('data-pdp2-cj')] === +b.getAttribute('data-i') ? 'true' : 'false');
      });
    }
    // enquanto o cliente nao mexeu nas opcoes do complemento, seguem a peca
    if (PK && escolhaPk.i >= 0 && !escolhaPk.mexeu) escolhaPk.o = valoresIniciais(PK.ops[escolhaPk.i]);
    var k = contas();
    pintarPack(k);

    // O resumo escreve-se sempre inteiro, com ou sem extras. So com o ramo
    // "com extras", tirar o estrado repunha o preco mas deixava o nome dele
    // escrito no botao e na barra: o pdp-2.js so reescreve a linha quando se
    // troca de tecido, e retirar um extra nao e troca de tecido.
    var nomes = extras().map(function (e) { return e.nome; });
    if (k.comp) nomes.push(nomeComp(k.comp));
    var precoTxt = nomes.length ? moeda(k.total) : camaActual.p;
    var selTxt = (opcoes.length ? camaActual.o.join(' · ') : '') +
      nomes.map(function (n) { return ' + ' + n; }).join('') +
      (k.menos ? ' · ' + tr('menos_no_pack', { p: moeda(k.menos) }) : '');
    ['[data-pdp2-comprar-preco]', '[data-pdp2-barra-preco]'].forEach(function (s) { var el = document.querySelector(s); if (el) el.textContent = precoTxt; });
    ['[data-pdp2-comprar-sel]', '[data-pdp2-barra-sel]'].forEach(function (s) { var el = document.querySelector(s); if (el) el.textContent = selTxt; });
    precoNaProva();
  }

  // A prova (o configurador em ecra inteiro) redesenha o seu preco a cada
  // toque. Com extras escolhidos, o botao de la acrescenta tudo — o preco
  // tem de o dizer; sem eles, volta ao da peca.
  function precoNaProva() {
    var el = raiz.querySelector('[data-pdp2-prova] .pdp2-prova__preco');
    if (!el || !camaActual) return;
    var k = contas();
    var nomes = extras().map(function (e) { return e.nome; });
    if (k.comp) nomes.push(nomeComp(k.comp));
    var t = !nomes.length ? camaActual.p : tr('preco_com', { p: moeda(k.total), itens: enumera(nomes) });
    if (el.textContent !== t) el.textContent = t;
  }
  var prova = raiz.querySelector('[data-pdp2-prova]');
  if ((CJ || PK) && prova && 'MutationObserver' in window) {
    new MutationObserver(precoNaProva).observe(prova, { childList: true, subtree: true, characterData: true });
  }

  if (cj) {
    cj.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pdp2-cj]');
      if (!b || b.disabled) return;
      escolhaCj[b.getAttribute('data-pdp2-cj')] = +b.getAttribute('data-i');
      pintarConjunto();
      pintarWa();
    });
  }
  if (PK) {
    pk.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pdp2-pk], [data-pdp2-pk-eixo], [data-pdp2-pk-tirar]');
      if (!b || b.disabled) return;
      if (b.hasAttribute('data-pdp2-pk-tirar')) {
        escolhaPk = { i: -1, o: null, mexeu: false };
      } else if (b.hasAttribute('data-pdp2-pk-eixo')) {
        escolhaPk.o[+b.getAttribute('data-pdp2-pk-eixo')] = b.getAttribute('data-valor');
        escolhaPk.mexeu = true;
      } else {
        var i = +b.getAttribute('data-pdp2-pk');
        // tocar outra vez no escolhido retira-o
        escolhaPk = escolhaPk.i === i ? { i: -1, o: null, mexeu: false } : { i: i, o: valoresIniciais(PK.ops[i]), mexeu: false };
      }
      pintarConjunto();
      pintarWa();
    });
  }

  // Comprar. So com a peca, o formulario segue como sempre. Com mais, vao
  // todos de uma vez pelo /cart/add.js. O estrado e o colchao levam as
  // propriedades que o carrinho agrupa (_bundle_group/_bundle_role/Conjunto) —
  // as mesmas da ficha antiga. O complemento do pack vai como linha propria,
  // sem elas: o carrinho iguala a quantidade dos componentes a da cama, e as
  // duas mesas passavam a uma.
  var form = document.getElementById('pdp2-form');
  var erro = raiz.querySelector('[data-pdp2-comprar-erro]');
  if (form && (CJ || PK)) {
    form.addEventListener('submit', function (e) {
      if (!camaActual) return;
      var ex = extras(), comp = complemento();
      if (!ex.length && !comp) return;
      e.preventDefault();
      var items = [{ id: camaActual.id, quantity: 1 }];
      if (ex.length) {
        var grupo = 'bg-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7);
        var com = function (papel) { return { '_bundle_group': grupo, '_bundle_role': papel, 'Conjunto': CJ.cama }; };
        items[0].properties = com('bed');
        ['estrado', 'colchao'].forEach(function (t) {
          var c = compDe(t, escolhaCj[t]);
          if (c) items.push({ id: c.v.id, quantity: 1, properties: com(t) });
        });
      }
      if (comp) items.push({ id: comp.v.id, quantity: comp.q });
      var botoes = document.querySelectorAll('button[form="pdp2-form"], #pdp2-form button[type="submit"]');
      botoes.forEach(function (b) { b.disabled = true; });
      if (erro) erro.hidden = true;
      var raizLoja = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(raizLoja + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, j: j }; });
      }).then(function (res) {
        if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || '');
        window.location.href = raizLoja + 'cart';
      }).catch(function (err) {
        botoes.forEach(function (b) { b.disabled = false; });
        if (erro) {
          erro.textContent = tr('erro_carrinho') + (err && err.message ? ' ' + err.message : '');
          erro.hidden = false;
        }
      });
    });
  }

  /* ---- 3. o WhatsApp com a peca la dentro ------------------------------ */

  function pintarWa() {
    var v = camaActual;
    var partes = v && opcoes.length ? v.o.slice(0, opcoes.length) : [];
    extras().forEach(function (e) { partes.push(e.nome); });
    var cp = complemento();
    if (cp) partes.push(nomeComp(cp));
    var url = location.origin + location.pathname + (v && opcoes.length ? '?variant=' + v.id : '');
    var txt = tr('wa', { t: D.titulo + (partes.length ? ' (' + partes.join(', ') + ')' : '') }) + ' ' + url;
    document.querySelectorAll('[data-pdp2-wa], .pistacho-wa').forEach(function (a) {
      var h = a.getAttribute('href') || '';
      var m = /^(https:\/\/wa\.me\/\d+)/.exec(h);
      if (m) a.setAttribute('href', m[1] + '?text=' + encodeURIComponent(txt));
    });
  }

  /* ---- a cada escolha --------------------------------------------------- */

  function aplicar(d) {
    var v = d && d.variante ? varPorId(d.variante) : variantes[0];
    if (!v) return;
    camaActual = v;
    pintarCustos(v.o.slice());
    pintarConjunto();
    pintarWa();
  }
  raiz.addEventListener('pdp2:escolha', function (e) { aplicar(e.detail); });
  aplicar(raiz._pdp2Escolha);
})();
